import requestCommon from "@/components/web-interface/requestCommon";
const state = {
};
const actions = {
  exitOrder(context, data) {
    return requestCommon.patchInfo(
      "/admin/orders/users/" + data.payload.userId + "/positions/instruments/" + data.payload.instrument,
      null,
      data.payload.body,
      context,
      "exitOrderSuccessHandler",
      "exitOrderErrorHandler",
    );
  },
  exitAll(context, data) {
    return requestCommon.patchInfo(
      "/admin/orders/users/" + data.payload.user + "/positions", null,
      data.payload.body,
      context,
      "exitAllSuccessHandler",
      "exitAllErrorHandler"
    );
  },
  squareOff(context, data) {
    return requestCommon.postInfo(
      "/orders/squareOff", null,
      data,
      context,
      "squareOffSuccessHandler",
      "squareOffErrorHandler",
    );
  },
  placeOrder(context, data) {
    return requestCommon.postInfo(
      "/admin/orders/users/" + data.payload.userId + "/instruments/" + data.payload.instrument,
      null,
      data.payload.body,
      context,
      "placeOrderSuccessHandler",
      "placeOrderErrorHandler"
    );
  },
  shutDown(context, data) {
    return requestCommon.patchInfo(
      "/systems/shutdown",
      null,
      data.payload,
      context,
      "shutDownSuccessHandler",
      "shutDownErrorHandler"
    );
  },
  pauseEntry(context, data) {
    return requestCommon.patchInfo("/systems/status/" + data.param.status, null,
      data.payload,
      context,
      "pauseEntrySuccessHandler",
      "pauseEntryErrorHandler")
  },
  playEntry(context, data) {
    return requestCommon.patchInfo("/systems/status/" + data.param.status, null,
      data.payload,
      context,
      "playEntrySuccessHandler",
      "playEntryErrorHandler")
  },
  exitAllOrders(context, data) {
    return requestCommon.patchInfo("/orders/exitAll", null,
      data,
      context,
      "exitAllOrdersSuccessHandler",
      "exitAllOrdersErrorHandler")
  },
  customPlaceOrder(context, data) {
    return requestCommon.postInfo(
      "/orders/custom/users",
      null,
      data,
      context,
      "customPlaceOrderSuccessHandler",
      "customPlaceOrderErrorHandler",
    );
  },
  userLogin(context, data) {
    return requestCommon.postInfo(
      "/users/" + data.userId + "/login",
      null,
      data,
      context,
      "getUserLoginSuccessHandler",
      "getUserLoginErrorHandler"
    );
  },
}
const mutations = {
  exitOrderSuccessHandler(context, data) {
    console.log(data);
  },
  exitOrderErrorHandler(context, error) {
    console.log(error);
  },
  exitAllSuccessHandler(context, data) {
    console.log(data);
  },
  exitAllErrorHandler(context, error) {
    console.log(error);
  },
  placeOrderSuccessHandler(context, data) {
    console.log(data);
  },
  placeOrderErrorHandler(context, error) {
    console.log(error);
  },
  playEntrySuccessHandler(context, data) {
    console.log(data);
  },
  playEntryErrorHandler(context, error) {
    console.log(error);
  },
  pauseEntrySuccessHandler(context, data) {
    console.log(data);
  },
  pauseEntryErrorHandler(context, error) {
    console.log(error);
  },
  exitAllOrdersSuccessHandler(context, data) {
    console.log(data);
  },
  exitAllOrdersErrorHandler(context, error) {
    console.log(error);
  },
  shutDownSuccessHandler(context, data) {
    console.log(data);
  },
  shutDownErrorHandler(context, error) {
    console.log(error);
  },
  squareOffSuccessHandler(context, data) {
    console.log(data);
  },
  squareOffErrorHandler(context, error) {
    console.log(error);
  },
  customPlaceOrderSuccessHandler(context, data) {
    console.log(data);
  },
  customPlaceOrderErrorHandler(context, error) {
    console.log(error);
  },
  getUserLoginSuccessHandler(context, data) {
    console.log(data);
  },
  getUserLoginErrorHandler(context, error) {
    console.log(error);
  }
};
const getters = {};
export const settingStore = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
